import { render, staticRenderFns } from "./uklon_logo.vue?vue&type=template&id=32aad6c2&scoped=true&"
import script from "./uklon_logo.vue?vue&type=script&lang=js&"
export * from "./uklon_logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aad6c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32aad6c2')) {
      api.createRecord('32aad6c2', component.options)
    } else {
      api.reload('32aad6c2', component.options)
    }
    module.hot.accept("./uklon_logo.vue?vue&type=template&id=32aad6c2&scoped=true&", function () {
      api.rerender('32aad6c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/uklon/location/tabs/image_tabs/uklon_logo.vue"
export default component.exports